export enum MonextStatus {
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  FAILED = "FAILED",
  INTERNAL_ERROR = "INTERNAL_ERROR"
}
